if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
      });
      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;

      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
// V46: THE PASSIVE OBSERVER
// 1. NO MATH: Removes forced reflows to cure the "First Load Freeze".
// 2. SRC-SWAP TRACKING: Instantly detects when the theme changes the image alt text.
// 3. PURE CSS LABELS: Zero HTML injection to keep mobile/desktop arrows perfect.

(function() {
    if (window.miikModelOverlayTracker) return;
    window.miikModelOverlayTracker = true;

    // --- 1. DATA DICTIONARY ---
    const modelData = {
        'andrea-l': "Andrea is 5'10\" in size L",
'andrea-l-long': "Andrea is 5'10\" in size L, long fit",
'andrea-l-regular': "Andrea is 5'10\" in size L, regular fit",
'bethany-s': "Bethany is 5'11\" in size S",
'bethany-s-regular': "Bethany is 5'11\" in size S, regular fit",
'bethany-s-long': "Bethany is 5'11\" in size S, long fit",
'bonnie-xs': "Bonnie is 5'0\" in size XS",
'bonnie-xs-petite': "Bonnie is 5'0\" in size XS, petite fit",
'bonnie-xs-regular': "Bonnie is 5'0\" in size XS, regular fit",
'bri-xl': "Bri is 5'5\" in size XL",
'bri-xxl': "Bri is 5'5\" in size XXL",
'bri-xl-petite': "Bri is 5'5\" in size XL, petite fit",
'bri-xl-regular': "Bri is 5'5\" in size XL, regular fit",
'bri-xxl-petite': "Bri is 5'5\" in size XXL, petite fit",
'bri-xxl-regular': "Bri is 5'5\" in size XXL, regular fit",
'carley-xxl': "Carley is 5'2\" in size XXL",
'carley-xxl-petite': "Carley is 5'2\" in size XXL, petite fit",
'carley-xxl-regular': "Carley is 5'2\" in size XXL, regular fit",
'carolyn-l': "Carolyn is 5'10\" in size L",
'carolyn-m': "Carolyn is 5'10\" in size M",
'carolyn-l-long': "Carolyn is 5'10\" in size L, long fit",
'carolyn-l-regular': "Carolyn is 5'10\" in size L, regular fit",
'carolyn-m-long': "Carolyn is 5'10\" in size M, long fit",
'carolyn-m-regular': "Carolyn is 5'10\" in size M, regular fit",
'christal-m': "Christal is 5'3\" in size M",
'christal-s': "Christal is 5'3\" in size S",
'christal-m-petite': "Christal is 5'3\" in size M, petite fit",
'christal-m-regular': "Christal is 5'3\" in size M, regular fit",
'christal-s-petite': "Christal is 5'3\" in size S, petite fit",
'christal-s-regular': "Christal is 5'3\" in size S, regular fit",
'christine-l': "Christine is 5'9\" in size L",
'christine-l-long': "Christine is 5'9\" in size L, long fit",
'christine-l-regular': "Christine is 5'9\" in size L, regular fit",
'colleen-xl': "Colleen is 5'3\" in size XL",
'colleen-xxl': "Colleen is 5'3\" in size XXL",
'colleen-xl-petite': "Colleen is 5'3\" in size XL, petite fit",
'colleen-xxl-petite': "Colleen is 5'3\" in size XXL, petite fit",
'cristina-xl': "Cristina is 5'5\" in size XL",
'cristina-xxl': "Cristina is 5'5\" in size XXL",
'cristina-xl-petite': "Cristina is 5'5\" in size XL, petite fit",
'cristina-xl-regular': "Cristina is 5'5\" in size XL, regular fit",
'cristina-xxl-petite': "Cristina is 5'5\" in size XXL, petite fit",
'cristina-xxl-regular': "Cristina is 5'5\" in size XXL, regular fit",
'donna-s': "Donna is 5'6\" in size S",
'donna-s-regular': "Donna is 5'6\" in size S, regular fit",
'erica-2x': "Erica is 5'8\" in size 2X",
'erica-3x': "Erica is 5'8\" in size 3X",
'erica-4x': "Erica is 5'8\" in size 4X",
'jenna-m': "Jenna is 5'9\" in size M",
'jenna-s': "Jenna is 5'9\" in size S",
'jenna-m-long': "Jenna is 5'9\" in size M, long fit",
'jenna-m-regular': "Jenna is 5'9\" in size M, regular fit",
'jenna-s-long': "Jenna is 5'9\" in size S, long fit",
'jenna-s-regular': "Jenna is 5'9\" in size S, regular fit",
'jillian-xl': "Jillian is 5'10\" in size XL",
'jillian-xxl': "Jillian is 5'10\" in size XXL",
'jillian-xl-long': "Jillian is 5'10\" in size XL, long fit",
'jillian-xl-regular': "Jillian is 5'10\" in size XL, regular fit",
'jillian-xxl-long': "Jillian is 5'10\" in size XXL, long fit",
'jillian-xxl-regular': "Jillian is 5'10\" in size XXL, regular fit",
'jo-xs': "Jo is 5'6\" in size XS",
'jo-xs-regular': "Jo is 5'6\" in size XS, regular fit",
'kaitlin-l': "Kaitlin is 5'9\" in size L",
'kaitlin-xl': "Kaitlin is 5'9\" in size XL",
'kaitlin-xxl': "Kaitlin is 5'9\" in size XXL",
'kaitlin-xl-long': "Kaitlin is 5'9\" in size XL, long fit",
'kaitlin-xl-regular': "Kaitlin is 5'9\" in size XL, regular fit",
'kaitlin-xxl-long': "Kaitlin is 5'9\" in size XXL, long fit",
'kaitlin-xxl-regular': "Kaitlin is 5'9\" in size XXL, regular fit",
'keethai-l': "Keethai is 5'5\" in size L",
'keethai-m': "Keethai is 5'5\" in size M",
'keethai-m-regular': "Keethai is 5'5\" in size M, regular fit",
'kelly-2x': "Kelly is 5'7\" in size 2X",
'kelly-3x': "Kelly is 5'7\" in size 3X",
'kelly-4x': "Kelly is 5'7\" in size 4X",
'kerri-m': "Kerri is 5'2\" in size M",
'kerri-m-petite': "Kerri is 5'2\" in size M, petite fit",
'kerri-m-regular': "Kerri is 5'2\" in size M, regular fit",
'kerri-s': "Kerri is 5'5\" in size S",
'kimesha-2x': "Kimesha is 5'8\" in size 2X",
'kimesha-3x': "Kimesha is 5'8\" in size 3X",
'kimesha-4x': "Kimesha is 5'8\" in size 4X",
'laurie-xl': "Laurie is 5'5\" in size XL",
'laurie-xxl': "Laurie is 5'5\" in size XXL",
'laurie-xl-petite': "Laurie is 5'5\" in size XL, petite fit",
'laurie-xl-regular': "Laurie is 5'5\" in size XL, regular fit",
'laurie-xxl-petite': "Laurie is 5'5\" in size XXL, petite fit",
'laurie-xxl-regular': "Laurie is 5'5\" in size XXL, regular fit",
'lex-xs': "Lex is 5'2\" in size XS",
'lex-xs-petite': "Lex is 5'2\" in size XS, petite fit",
'lex-xs-regular': "Lex is 5'2\" in size XS, regular fit",
'liane-s': "Liane is 5'9\" in size S",
'liane-s-long': "Liane is 5'9\" in size S, long fit",
'liane-s-regular': "Liane is 5'9\" in size S, regular fit",
'lisa-xs': "Lisa is 5'6\" in size XS",
'lisa-xs-long': "Lisa is 5'6\" in size XS, long fit",
'lisa-xs-regular': "Lisa is 5'6\" in size XS, regular fit",
'marilyn-m': "Marilyn is 5'2\" in size M",
'marilyn-s': "Marilyn is 5'2\" in size S",
'marilyn-m-petite': "Marilyn is 5'2\" in size M, petite fit",
'marilyn-m-regular': "Marilyn is 5'2\" in size M, regular fit",
'marilyn-s-petite': "Marilyn is 5'2\" in size S, petite fit",
'marilyn-s-regular': "Marilyn is 5'2\" in size S, regular fit",
'melanie-m': "Melanie is 5'9\" in size M",
'melanie-m-long': "Melanie is 5'9\" in size M, long fit",
'melanie-m-regular': "Melanie is 5'9\" in size M, regular fit",
'meron-xs': "Meron is 5'3\" in size XS",
'meron-xs-petite': "Meron is 5'3\" in size XS, petite fit",
'meron-xs-regular': "Meron is 5'3\" in size XS, regular fit",
'pat-l': "Pat is 5'8\" in size L",
'pat-l-long': "Pat is 5'8\" in size L, long fit",
'pat-l-regular': "Pat is 5'8\" in size L, regular fit",
'raquel-xl': "Raquel is 5'7\" in size XL",
'raquel-xxl': "Raquel is 5'7\" in size XXL",
'raquel-xl-long': "Raquel is 5'7\" in size XL, long fit",
'raquel-xl-regular': "Raquel is 5'7\" in size XL, regular fit",
'raquel-xxl-long': "Raquel is 5'7\" in size XXL, long fit",
'raquel-xxl-regular': "Raquel is 5'7\" in size XXL, regular fit",
'yasmine-xs': "Yasmine is 5'0\" in size XS",
'yasmine-xs-petite': "Yasmine is 5'0\" in size XS, petite fit",
'yasmine-xs-regular': "Yasmine is 5'0\" in size XS, regular fit",
'sarita-2x': "Sarita is 5'7 in size 2x",
'kerri-s-regular': "Kerri is 5\"5 in size S, regular fit",
'sarita-xxl-regular': "Sarita is 5'7\" in size XXL, regular fit",
'natasha-s': "Natasha is 5'4 in size S",
'natasha-s-regular': "Natasha is 5'4 in size S, regular fit",
'natahsa-s-long': "Natahsa is 5'4 in size S, long fit",
'colleen-xxl-long': "Colleen is 5'3 in size XXL, long fit",
'keethai-m-long': "Keethai is 5'5 in size M, long fit", 
'kelly-xxl-regular': "Kelly is 5'7\" in size XXL, regular fit",
'kerri-s-petite': "Kerri is 5'2 in size S, petite fit",
'laurie-l': "Laurie is 5'5 in size L",
'terry-s': "Terry is 5'1\" in size S",
'terry-s-petite': "Terry is 5'1\" in size S, petite fit",
'sureka-2x': "Sureka is 5'9\" in size 2x",
'sureka-3x': "Sureka is 5'9\" in size 3x",
'donna-s-long': "Donna is 5'6\" in size S, long fit",
'sue-xs': "Sue is 5'4\" in size XS",
'sue-xs-petite': "Sue is 5'4\" in size XS, petite fit",
'sue-xs-regular': "Sue is 5'4\" in size XS, regular fit",
'rae-xs': "Rae is 5'3\" in size XS",
'rae-s': "Rae is 5'3\" in size S",
'rae-xs-regular': "Rae is 5'3\" in size XS, regular fit",
'rae-s-regular': "Rae is 5'3 in size S, regular fit",
'ana-s': "Ana is 5'6\" in size S",
'ana-s-regular': "Ana is 5'6\" in size S, regular fit",
'rose-m': "Rose is 5'9\" in size M",
'rose-m -regular': "Rose is 5'9\" in size M , regular fit",
'deb-xl': "Deb is 5'6\" in size XL",
'deb-xl-regular': "Deb is 5'6\" in size XL, regular fit",'rula-l': "Rula is 5'4\" in size L",
'rula-l-regular': "Rula is 5'4\" in size L, regular fit",
'terry-xs': "Terry is 5'1\" in size XS", 'meron-s': "Meron is 5'3 in size S"
    };

    // --- CORE LOGIC ---
    function updateOverlay(img) {
        if (!img || !img.alt) return;
        
        // THE FIX: Tell the script to ignore the tiny tooltip thumbnail!
        if (img.classList.contains('hotspot-img')) return; 
        
        // Find the safe wrapper to apply the CSS attribute to
        const container = img.closest('.product__media') || img.closest('.product__media-item');
        if (!container) return;

        // Extract the Tag
        const parts = img.alt.split('@');
        let description = null;

        if (parts.length >= 2) {
            let rawTag = parts[1].trim(); 
            let lookupKey = rawTag.split(' ')[0].toLowerCase().replace(/[^a-z0-9-_]/g, '');
            description = modelData[lookupKey];
        }

        // Apply or Remove the attribute quietly
        if (description) {
            if (container.getAttribute('data-model-overlay') !== description) {
                container.setAttribute('data-model-overlay', description);
            }
        } else {
            container.removeAttribute('data-model-overlay');
        }
    }

    // --- STARTUP ---
    function init() {
        document.querySelectorAll('.product__media img, .product__media-item img').forEach(updateOverlay);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // --- THE SILENT OBSERVER ---
    // This strictly watches for the theme swapping the "alt" tag, and fixes the text instantly.
    const observer = new MutationObserver((mutations) => {
        mutations.forEach(m => {
            // Did the theme swap the image src/alt?
            if (m.type === 'attributes' && m.attributeName === 'alt') {
                updateOverlay(m.target);
            } 
            // Did the theme load a new variant block?
            else if (m.type === 'childList') {
                m.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // If it's an element
                        if (node.tagName === 'IMG') {
                            updateOverlay(node);
                        } else if (node.querySelectorAll) {
                            node.querySelectorAll('.product__media img, .product__media-item img').forEach(updateOverlay);
                        }
                    }
                });
            }
        });
    });

    // Attach to the body to catch everything, but filter strictly for performance
    observer.observe(document.body, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['alt'] 
    });

})();